export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./refuse-lead.vue?vue&type=template&id=1345e328&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/refuse-lead.vue?vue&type=template&id=1345e328&
// module id = 1680
// module chunks = 0